import { Outlet } from "react-router-dom";
import HeaderComp from "../header";
import FooterComp from "../footer";

const Layout = () => {
  return (
    <>
      <HeaderComp />
      <div className="content-outlet">
        <Outlet />
      </div>
      <FooterComp />
    </>
  )
};

export default Layout;